import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IDocumentTypeStateDTO } from "./document-type-state.dto";
import { DOCUMENT_TYPE_FEATURE_KEY } from "./document-type.config";
import { HttpActionState } from "app/main/pages/users/userslisting/store/users-listing.reducers";

export const documentTypeFeatureSelector = createFeatureSelector<IDocumentTypeStateDTO>(DOCUMENT_TYPE_FEATURE_KEY);


export const selectDocumentTypeLayoutSettings = createSelector(documentTypeFeatureSelector, (state) => state.documentTypeLayoutSettings);
export const selectFetchDocumentTypeLayoutSettingsRequestState = createSelector(documentTypeFeatureSelector, (state) => state.fetchDocumentTypeLayoutSettingsRequestState);

export const selectMetaDataFields = createSelector(documentTypeFeatureSelector, (state) => state.metaDataFields);
export const selectFetchMetaDataFieldsRequestState = createSelector(documentTypeFeatureSelector, (state) => state.fetchMetaDataFieldsRequestState);

export const selectUpdateLayoutSettingsRequestState = createSelector(documentTypeFeatureSelector, (state) => state.updateLayoutSettingsRequestState);

export const selectUpdateDocumentTypeSelectorRequestState = createSelector(documentTypeFeatureSelector, (state) => state.updateDocumentTypeSelectorRequestState === HttpActionState.Busy);